
import { mapMutations } from 'vuex';
export default {
  name: 'GlobalCodeBox',
  props: {
    globalJs: {
      type: String,
      default: '',
    },
    globalJsGroup: {
      type: Array,
      default: () => [],
    },
    globalHtml: {
      type: String,
      default: '',
    },
  },
  head() {
    var js_search_arr = [];
    if (this.globalHtml) {
      let reg =
        /<script(?:(?:\s|.)+?)src=["'](.+?)["'](?!<)(?:(?:\s|.)*?)(?:(?:\/>)|(?:>\s*?<\/script>))/gi;
      this.globalHtml.replace(reg, (match, p1) => {
        js_search_arr.push({
          src: p1,
        });
        return '';
      });
    }
    return {
      script: js_search_arr,
    };
  },
  mounted() {
    const element = this.$el;
    const newScript = document.createElement('script');
    let scriptCode = '';
    if (this.globalJs && this.globalJs !== '') {
      scriptCode = `
        try {
          (function () {
            ${this.globalJs}
          })();
        } catch (err) {
          console.error("GlobalJs Err", err);
        }
      `;
    } else if (this.globalJsGroup && this.globalJsGroup.length) {
      this.globalJsGroup.forEach((item) => {
        scriptCode += `
          try {
            (function () {
              ${item.code}
            })();
          } catch (err) {
            console.error('GlobalJs ${item.id} Err', err);
            window.$nuxt.$sentry.captureException(err, {
              level: 'fatal',
              tags: {
                error: 'GlobalJs Err',
              },
              extra: {
                itemId: '${item.id}',
                debugInfo: window.moo?.code + 'GlobalJs ${item.id} Err',
              },
            });
          }
        `;
      });
    }
    /*
    TODO 在登录完之后注入用户信息
    Sentry.configureScope(scope => {
      scope.setUser({
        id: '12345',
        email: 'user@example.com',
        username: 'exampleUser'
      });
    });
    */
    newScript.innerHTML = scriptCode;
    try {
      element.appendChild(newScript);
    } catch (error) {
      console.error('GlobalJs Load Err', error);
    }

    if (this.globalHtml && this.globalHtml !== '') {
      let reg =
        /<script(?:(?:\s|.)+?)src=["'](.+?)["'](?!<)(?:(?:\s|.)*?)(?:(?:\/>)|(?:>\s*?<\/script>))/gi;

      const str = this.globalHtml.replace(reg, '');

      const element = this.$el;
      const newScript = document.createElement('div');
      newScript.innerHTML = str;
      element.appendChild(newScript);
    }
  },
};
